<script>
// 第三方组件
export default {
  name: 'RenderCmp',
  props: {
    renderF: {
      type: Function,
      default: () => {}
    }
  },
  data () {
    return {
      initData: null,
      initFormData: {},
      target: null
    }
  },
  created () {},
  mounted () {
    // console.log('RenderCmp-end')
    // console.log('this.renderF',this.renderF)
  },
  methods: {},
  // render:this.renderF
  render (h) {
    const that = this
    return <div>{that.renderF(h)}</div>
  }
}
</script>

<style lang="scss">
@import '../../../index';
</style>
